<template>

  <div class="workspace">
    <div class="section-heading">
      <h2>Billing</h2>
    </div>
    <div class="billing-nav">
      <div id="payment-method" class="tab" :class="[activeTab === 0 ? 'active' : '']" @click="clickTab('subscriptions')">Subscriptions</div>
      <div id="payment-method" class="tab" :class="[activeTab === 1 ? 'active' : '']" @click="clickTab('payment-method')">Payment Method</div>
      <div id="payment-history" class="tab" :class="[activeTab === 2 ? 'active' : '']" @click="clickTab('payment-history')">Payment History</div>
      <div id="upcoming-payments" class="tab" :class="[activeTab === 3 ? 'active' : '']" @click="clickTab('upcoming-payment')">Upcoming Payments</div>
      <div v-if="makePaymentStatus" id="upcoming-payments" class="tab" :class="[activeTab === 4 ? 'active' : '']" @click="clickTab('make-payment')">Make Payment</div>
    </div>
    <div>
      <div id="payment-method-window" v-if="activeTab === 0" class="billing-window">
        <div class="billing-heading">
          <h2>Subscriptions</h2>
        </div>
        <div class="payment-table" v-if="subscriptions">
          <div class="table-row" v-for="(subscription, index) in subscriptions" :key="index">
            <div class="table-column w40"> {{subscription.plan.product.name}}</div>
            <div class="table-column w20">{{unixFormatDate(subscription.current_period_end)}}</div>
            <div class="table-column w10">${{(subscription.plan.amount/100).toFixed(2)}}</div>
            <div class="table-column w20" v-if="!['active','trialing'].includes(subscription.status)" @click="activeTab = 4"><i class="fas fa-newspaper"></i><b>Make Payment</b></div>
            <div class="table-column w10"><div @click="cancelSubscription(subscription.id)"><i class="fas fa-unlink"></i> <b>Cancel</b></div></div>
          </div>
        </div>
        <div class="add-payment">
          <div class="al-button" v-if="subscriptions && subscriptions.length===0 || !subscriptions" @click="newSubscription()">Subscription Start</div>
        </div>
      </div>
      <div id="payment-method-window" v-if="activeTab === 1" class="billing-window">
        <div class="billing-heading">
          <h2>Saved Payment Methods</h2>
        </div>
        <div class="payment-table" v-if="cards">
          <div class="table-row" v-for="(card, index) in cards_list" :key="index">
            <div class="table-column w40"> {{card.card.brand}} ending in <span class="card-ending">{{ card.card.last4 }}</span> (Expires {{ card.card.exp_month }}/{{ card.card.exp_year }})</div>
            <div class="table-column w20" ><img :src="card.card.brand === 'visa' ? '/img/cards/visa.svg' : '/img/cards/mastercard.svg'" /></div>
            <div class="table-column w20" v-if="card.id === currentUser.payment_method">(Default)</div>
            <div class="table-column w20" v-else><a @click="makeDefault(card.id)">Make Default</a></div>
            <div class="table-column w20"><div @click="deleteCard(card.id)"><i class="fas fa-trash-alt"></i> Delete</div></div>
          </div>
        </div>
        <div class="add-payment">
          <div class="al-button" @click="proceedCardInfo">Add New Payment Method</div>
        </div>
      </div>
      <div id="payment-history-window" v-if="activeTab === 2" class="billing-window">
        <div class="billing-heading">
          <h2>Payment History</h2>
        </div>

        <div class="history-list">
          <div class="date-select">
            <div class="row">
              <div class="column">
                <label>From
                  <input type="date" class="al-input"/>
                </label>
              </div>
              <div class="column">
                <label>To
                  <input type="date" class="al-input"/>
                </label>
              </div>
            </div>
          </div>

          <div class="invoice-table" v-if="invoices">
            <div class="table-heading">
              <div class="table-column-h">Date</div>
              <div class="table-column-h">Transaction</div>
              <div class="table-column-h">Amount</div>
              <div class="table-column-h">Documents</div>
            </div>
            <div class="table-row" v-for="(invoice, index) in invoices" :key="index">
              <div class="table-column">{{ getRegularDate(invoice.created) }}</div>
              <div class="table-column" :title="`${firstLetterCapitalize(invoice.subscription.status)}: ${invoice.subscription.plan.product.name}`">{{ firstLetterCapitalize(invoice.subscription.status) }} :  {{ invoice.subscription.plan.product.name }}</div>
              <div class="table-column">${{ invoice.total / 100 }}</div>
              <div class="table-column"><a @click.prevent="downloadItem(invoice.invoice_pdf)">Invoice</a></div>
            </div>
          </div>
        </div>
      </div>
      <div id="upcoming-payment-window" v-if="activeTab === 3" class="billing-window">
        <div class="billing-heading">
          <h2>Upcoming Payments</h2>
        </div>

        <div class="history-list">
          <div class="date-select">
            <div class="row">
              <div class="column">
                <label>From
                  <input type="date" class="al-input"/>
                </label>
              </div>
              <div class="column">
                <label>To
                  <input type="date" class="al-input"/>
                </label>
              </div>
            </div>
          </div>

          <div class="upcoming-table" v-if="upcoming">
            <div class="table-heading">
              <div class="table-column-h">Date</div>
              <div class="table-column-h">Transaction</div>
              <div class="table-column-h">Amount</div>
            </div>
            <div class="table-row" v-for="(invoice, index) in upcoming" :key="index">
              <div class="table-column">{{ getRegularDate(invoice.next_payment_attempt) }}</div>
              <div class="table-column" :title="`${firstLetterCapitalize(invoice.billing_reason)}: ${invoice.subscription.plan.product.name}`">{{ firstLetterCapitalize(invoice.billing_reason) }} :  {{ invoice.subscription.plan.product.name }}</div>
              <div class="table-column">${{ invoice.total / 100 }}</div>
            </div>

          </div>
        </div>
      </div>
      <div id="payment-method-window" v-if="activeTab === 4 && makePaymentStatus" class="billing-window">
        <div class="billing-heading">
          <h2>Make A Payment</h2>
        </div>
        <div class="cart-form-row">
          <div class="cart-form-label">Payment Amount</div>
          <div class="cart-form-input">
            <div class="cart-flex-item">
            <input disabled class="cart-input"
             type="text"
             :value="total_price">
            </div>
          </div>
        </div>
        <div class="cart-form-row">
          <div class="cart-form-label">Saved Payment Methods</div>
          <div class="cart-form-input">
            <div class="cart-flex-item">
              <select class="cart-input" v-model="paymentMethod" @change="handleCardSelection">
                <option value="">Select Payment Method</option>
                <option :selected="card.id === currentUser.payment_method" :value="card.id" :key="index" v-for="(card, index) in cards_list">
                  {{card.card.brand}} ending in {{ card.card.last4 }} (Expires {{ card.card.exp_month }}/{{ card.card.exp_year }})
                </option>
                <option value="addCard">Add Payment Method</option>
              </select>
            </div>
          </div>
        </div>
        <div class="add-payment">
          <div class="al-button" @click="submitPayment()">Submit Payment</div>
        </div>
      </div>
    </div>
    <payment-popup v-if="showPopup" :card_info="saved_card_info" :use_saved_card="saved_card" :price="'1'" :updated="cardInfoUpdated" :cancel="cardCancelled"/>
  </div>
</template>

<script>
import PaymentPopup from './PaymentPopup'
import printPdfTemplate from '../../../layouts/components/pdf/printPdfTemplate'
import moment from 'moment'
export default {
  name: 'Billing',
  props: {
    tab: {
      type: String
    }
  },
  data () {
    return {
      showDetail: false,
      print: false,
      printItem: null,
      showPopup: false,
      saved_card_info: '',
      saved_card: false,
      refresh: false,
      cards: null,
      activeTab: 0,
      subscriptions: null,
      invoices: [],
      upcoming: [],
      product: null,
      paymentMethod: '',
      makePaymentStatus: false
    }
  },
  metaInfo () {
    return {
      title: 'Billing',
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Manage your billing settings'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  },
  components: {
    PaymentPopup,
    printPdfTemplate,
    moment
  },
  mounted () {
    this.getUserCards()
    this.getSubscriptions()
    this.getBundle()
    this.checkTab()
  },
  watch: {
    refresh () {
      if (this.refresh) {
        setTimeout(() => {
          this.refresh = false
        }, 500)
      }
    },
    tab () {
      this.checkTab()
    }
  },
  computed: {
    total_price () {
      let totalPrice = '$'
      if (this.product) {
        totalPrice += this.product.price.toFixed(2) // + (this.product.price * 0.0875)).toFixed(2)
      }
      if (this.product) {
        totalPrice += `/${this.product.freq.charAt(0).toUpperCase() + this.product.freq.slice(1)}`
      }
      return totalPrice
    },
    /*newCard () {
      return parseInt(this.$route.query.newCard)
    },*/
    getDefaultCard () {
      //<div class="table-column w40"> {{card.card.brand}} ending in <span class="card-ending">{{ card.card.last4 }}</span> (Expires 07/27)</div>
      const result = this.cards_list.filter(card => {
        if (card.id === this.currentUser.payment_method) {
          return card
        }
      })
      console.log(result[0])
      return result[0]
    },
    currentUser () {
      return this.$store.state.AppActiveUser
    },
    cards_list () {
      const arr = JSON.parse(JSON.stringify(this.cards))
      return arr.sort((a, b) => {
        const dateA = new Date(a.created)
        const dateB = new Date(b.created)
        return dateA - dateB
      })
    },
    user () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    checkMakePayment () {
      this.subscriptions.map(subscription => {
        if (!this.makePaymentStatus && !['active', 'trialing'].includes(subscription.status)) {
          this.makePaymentStatus = true
        }
      })
    },
    clickTab (tab) {
      this.$router.push({name: this.$route.name, params: {tab}})
    },
    checkTab () {
      if (this.tab === 'subscriptions') {
        this.activeTab = 0
      } else if (this.tab === 'payment-method') {
        this.activeTab = 1
      } else if (this.tab === 'payment-history') {
        this.activeTab = 2
      } else if (this.tab === 'upcoming-payment') {
        this.activeTab = 3
      } else if (this.tab === 'make-payment') {
        this.activeTab = 4
      }
    },
    submitPayment () {
      if (this.paymentMethod === '') {
        this.$vs.notify({
          title: 'Failed',
          text: 'Please select payment method',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert'
        })
        return false
      }

      const payload = {
        paymentMethod: this.paymentMethod,
        user: this.user
      }
      this.loading = true
      this.$store.dispatch('subscriptionPayment', payload)
        .then((response) => {
          console.log(response)
          this.$vs.notify({
            title: 'Success',
            text: 'Payment Successful',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })
          setTimeout(() => {
            location.replace('/billing/subscriptions').reload()
          }, 1500)
        })
        .catch((error) => {
          console.log(error)
          this.$vs.notify({
            title: 'Failed',
            text: error.message,
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert'
          })
        })
    },
    handleCardSelection (event) {
      if (event.target.value === 'addCard') {
        this.activeTab = 1
      }
    },
    getBundle () {
      this.$store.dispatch('getBundleSlug', 'digital-scratch-off-campaigner-4')
        .then(response => {
          console.log('bundleslug', response)
          this.product = this.setPrices(response.data.data)
          console.log('product', this.product)
        })
        .catch(e => {
          console.log(e)
        })
    },
    setPrices (product) {
      try {
        product.price = product.price / 100
        product.serviceList.map(service => {
          service.price = service.price / 100
        })
        return product
      } catch (e) {
        console.log('set price error', e)
      }
    },
    formatDate (str) {
      return moment(new Date(str)).format('M/d/yyyy')
    },
    unixFormatDate (str) {
      const dateMoment = moment.unix(str)
      return dateMoment.format('M/D/YYYY')
    },
    downloadItem (url) {
      console.log(url)
      window.open(url, '_blank')
    },
    printReceipt (invoice) {
      console.log('got invo', invoice)
      this.print = true
      invoice.billing_address = JSON.parse(invoice.subscription.metadata.address)
      invoice.customer_name = invoice.subscription.metadata.customer_name
      //invoice.card = this.getDefaultCard
      this.printItem = invoice
      setTimeout(() => {
        this.print = false
        this.printItem = null
      }, 500)
    },
    getRegularDate (unix_timestamp) {
      return new Date(unix_timestamp * 1000).toDateString()
    },
    firstLetterCapitalize (str) {
      return str.substring(0, 1).toUpperCase().concat(str.substring(1))
    },
    cardInfoUpdated (info) {
      console.log(info)
      this.showPopup = false
      this.$router.push({name: this.$route.name})
      location.reload()
    },
    cardCancelled () {
      this.showPopup = false
    },
    proceedCardInfo () {
      this.saved_card = false
      this.showPopup = true
    },
    payWithSaved () {
      this.saved_card = true
      this.showPopup = true
    },
    refreshLayout () {
      this.refresh = true
    },
    newSubscription () {
      console.log('intentProduct', this.product)
      const payload = {
        bundle_id: this.product._id,
        user: this.user
      }
      this.$store.dispatch('newSaleMakePayment', payload)
        .then((response) => {
          console.log('pi', response)
          location.reload()
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },
    makeDefault (pm) {
      const payload = {
        payment_method: pm
      }
      this.$vs.loading()
      this.$store.dispatch('makeDefault', payload)
        .then((response) => {
          console.log('success save_card', response)
          location.reload()
          this.$vs.loading.close()
        })
        .catch((e) => {
          console.log(e)
          this.$vs.notify({
            title: 'Failed',
            text: 'Save Card Failed',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert'
          })

          this.$vs.loading.close()
        })
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    openSubscriptionConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to cancel your subscription?',
        accept,
        cancel
      })
    },
    deleteCard (pm) {
      this.openConfirm(() => {
        this.$validator.validateAll().then(result => {
          if (result) {

            this.$vs.loading()

            this.$store.dispatch('deleteCard', pm)
              .then(response => {
                console.log('response', response)
                this.$vs.loading.close()
                location.reload()
              })
              .catch(err => {
                console.error(err)
              })

          }
        })
      }, () => {})
    },
    cancelSubscription (pm) {
      this.openSubscriptionConfirm(() => {
        this.$validator.validateAll().then(result => {
          if (result) {

            this.$vs.loading()

            this.$store.dispatch('cancelSubscription', pm)
              .then(response => {
                console.log('response', response)
                this.$vs.loading.close()
                location.reload()
              })
              .catch(err => {
                console.error(err)
              })

          }
        })
      }, () => {})
    },
    getUserCards () {
      this.$vs.loading()
      this.$store.dispatch('getUserCards')
        .then((response) => {
          console.log(response)
          this.cards = response.data.data
          this.refreshLayout()
          this.paymentMethod =  this.currentUser.payment_method ? this.currentUser.payment_method : ''
          this.$vs.loading.close()
        })
        .catch((e) => {
          console.log(e)

          this.$vs.loading.close()
        })

    },
    getInvoice (sub_id, callback) {
      this.$vs.loading()
      const payload = {
        subscriptionId: sub_id
      }
      this.$store.dispatch('getInvoice', payload)
        .then((response) => {
          const invoice = response.data.invoice
          const upcoming = response.data.upcoming
          callback(invoice, upcoming)
          this.$vs.loading.close()
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },
    handleSubsToInvoice () {
      this.invoices = []
      this.subscriptions.map(subscription => {
        this.getInvoice(subscription.id, (invoices, upcoming) => {
          const inv_data = invoices.data.map(invoice => {
            const item = invoice
            item.subscription = subscription
            return item
          })

          upcoming.subscription = subscription
          this.invoices.push(...inv_data)
          this.upcoming.push(upcoming)
          console.log(this.upcoming)
        })
      })
    },
    getSubscriptions () {
      this.$vs.loading()
      this.$store.dispatch('getSubscriptions')
        .then((response) => {
          this.subscriptions = response.data.subscriptions.data
          this.checkMakePayment()
          console.log(this.subscriptions, 'subs')
          //this.handleSubsToInvoice()
          this.$vs.loading.close()
        })
        .catch((e) => {
          console.log(e)

          this.$vs.loading.close()
        })

    }
  }

}
</script>

<style scoped>
.row {
  margin:0;
}

.cart-form-row {
  width:100%;
}
.cart-form-label{
  font-size:20px;
  font-weight: 600;
  color:#005488;
  margin-bottom:15px;
}
.cart-input{
  width:100%;
  border:1px solid #ccc;
  border-radius: 7px;
  padding:10px;
  background-color:#f9f9f9f9;
}
.cart-input:focus{
  outline-color:#f08028;
}
.cart-form-input {
  margin-bottom:10px;
}
.cart-flex-row{
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.cart-flex-item{
  width:32%;

}
</style>
